export default "__VITE_ASSET__DZ3fbTik__"